import { render, staticRenderFns } from "./malware2.vue?vue&type=template&id=e8ac01ba&"
import script from "./malware2.vue?vue&type=script&lang=js&"
export * from "./malware2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports